import { render, staticRenderFns } from "./Pcas.vue?vue&type=template&id=09186e48"
import script from "./Pcas.vue?vue&type=script&lang=js"
export * from "./Pcas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports